import React, { useState, useRef, useEffect, Suspense } from "react"
import { Layout, SEO, Playground } from "../components"
import * as THREE from "three"
import { useSpring, a } from "react-spring/three"
import model from "../components/crystal_web.glb"
import { OrbitControls, draco } from "drei"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import {
  Canvas,
  extend,
  useThree,
  useFrame,
  useLoader,
} from "react-three-fiber"

extend({ OrbitControls })

const Model = () => {
  const { nodes, materials } = useLoader(GLTFLoader, model, draco())
  // console.log(nodes)
  // console.log(materials)
  return (
    <group position={[1, 0, 2]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Circle_0.geometry}
        material={nodes.Circle_0.material}
      ></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Circle_1.geometry}
        material={nodes.Circle_1.material}
      ></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Circle_2.geometry}
        material={nodes.Circle_2.material}
      ></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Circle_3.geometry}
        material={nodes.Circle_3.material}
      ></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Circle_4.geometry}
        material={nodes.Circle_4.material}
      ></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Circle_5.geometry}
        material={nodes.Circle_5.material}
      ></mesh>
    </group>
  )
}

const PlaygroundPage = () => (
  <Layout page="playground" playground>
    <SEO title="Playground" />
    <Playground>
      <Canvas
        camera={{ position: [0, 0, 7] }}
        onCreated={({ gl }) => {
          gl.shadowMap.enabled = true
          gl.shadowMap.type = THREE.PCFShadowMap
        }}
      >
        <pointLight position={[0, 10, 0]} intensity={3} castShadow />
        <spotLight
          position={[0, 9, 10]}
          lookAt={[0, 0, 0]}
          penumbra={1}
          color={"#FFD7AB"}
          castShadow
        />
        <spotLight
          position={[10, 9, 0]}
          lookAt={[0, 0, 0]}
          penumbra={1}
          castShadow
        />
        <fog attach="fog" args={["#1C1E20", 30, 40]} />
        <OrbitControls
          autoRotate
          maxPolarAngle={Math.PI / 3}
          minPolarAngle={Math.PI / 3}
          enableZoom={false}
        />
        <Suspense fallback={null}>
          {/* <Box /> */}
          {/* <Plane /> */}
          <Model />
        </Suspense>
      </Canvas>
    </Playground>
  </Layout>
)

export default PlaygroundPage
